import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
export const ArrowUpIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24532 3.55839L2.13486 5.66734C1.83941 5.96128 1.3611 5.96203 1.06565 5.66659C0.770959 5.37189 0.770959 4.89283 1.06641 4.59813L5.00095 0.665859L8.93398 4.59813C9.22943 4.89283 9.22943 5.37189 8.93398 5.66659C8.63853 5.96203 8.16097 5.96203 7.86552 5.66659L5.75657 3.55839L5.75657 12.0002C5.75657 12.4173 5.41805 12.7559 5.00095 12.7559C4.58384 12.7559 4.24532 12.4173 4.24532 12.0002V3.55839Z",
    fill: color
  }));
};
export default ArrowUpIcon;